export default __webpack_public_path__ + "empty-catalog-md.1dd8f56f.svg";